const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/PDF/36pt"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25647"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13622",
    d: "M30.172 137a2 2 0 0 1 1.414.586l7.828 7.828a2 2 0 0 1 .586 1.414V164a3.009 3.009 0 0 1-3 3H18.985A3 3 0 0 1 16 164v-24a3.009 3.009 0 0 1 3-3zm.828 1.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    transform: "translate(-10 -134)",
    style: {
      fill: "#212121",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13623",
    d: "M21.11 158v-6.336h-2.148v-1.488h6.072v1.488h-2.148V158zm3.618 0 2.172-4.02-2.04-3.8h1.968l.684 1.476q.132.276.264.588t.3.672h.048q.132-.372.252-.672t.252-.588l.624-1.476h1.884l-2.028 3.888 2.16 3.932H29.3l-.78-1.6q-.144-.312-.288-.612t-.3-.672h-.048q-.132.36-.264.672t-.264.612l-.732 1.6zm8.39 0v-6.336H30.97v-1.488h6.072v1.488h-2.148V158z",
    transform: "translate(-10 -134)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/TEXT.327525a190d8e107d00d54b02550d4e6.svg";
export { ForwardRef as ReactComponent };